/*
 *
 * Groups constants
 *
 */

export const SLICE_NAME = 'groups';
